import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDoubanComponent } from './simple-icons-douban.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDoubanComponent ],
    exports:      [ SimpleIconsDoubanComponent ],
    bootstrap:    []
})
export class SimpleIconsDoubanModule {}
